import moment from 'moment-timezone';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import utils from '../../../services/utils';
import Button from '../../Buttons/Button/Button';
import FieldBold from '../../Fields/FieldBold/FieldBold';
import ProgressBar from '../../ProgressBar/ProgressBar';
import { ReactComponent as Calendar } from '../../../assets/icons/Calendar.svg';
import { ReactComponent as Trash } from '../../../assets/icons/Trash.svg';
import Tags from '../../Tags/Tags';
import InvoiceDetail from '../../Details/InvoiceDetail/InvoiceDetail';
import Context from '../../../store/context';
import { typesStatusAccount } from '../../../store/constants/statusDruoAccounts';

import classes from './DetailsClientCard.module.scss';

const statusLabel = {
  [typesStatusAccount.SUCCESS]: {
    label: 'Conectado',
    color: 'green'
  },
  [typesStatusAccount.PROCESSING]: {
    label: 'En Proceso',
    color: 'orange'
  },
  [typesStatusAccount.ERROR]: {
    label: 'Error',
    color: 'failed'
  },
  [typesStatusAccount.DISCONNECTED]: {
    label: 'Pendiente',
    color: 'gray'
  }
};

const DetailsClientCard = ({
  className,
  onClick,
  client,
  isChecked,
  payed = false,
  deleteHandler,
  isSupplier = false,
  isModal = false,
  refetch
}) => {
  const { individualName, totalCharges, valuePendingCharges, expiration } = client;

  const {
    modal: { showModal }
  } = useContext(Context);

  const containerClasses = [
    'card-check',
    payed ? classes['card-process'] : '',
    isModal ? classes['card-modal'] : classes['card-not-modal']
  ];
  if (isChecked) {
    containerClasses.push('border-selected');
  }
  if (className) {
    containerClasses.push(className);
  }

  return (
    <div className={`${containerClasses.join(' ')} ${classes.card}`}>
      <div className={classes.title}>
        <span className={`${classes.business} semibold-18 text-ellipsis`}>{individualName}</span>
        {/*  <div className={classes.status}>
          <Tags text={statusLabel[statusAccount]?.label} type={statusLabel[statusAccount]?.color} />
        </div> */}
      </div>
      <div className={classes.fields}>
        <FieldBold title='PENDIENTES' value={totalCharges} />
        <FieldBold title='DEUDA TOTAL' value={utils.moneyFormat(valuePendingCharges)} />
        <FieldBold
          className={classes.mobile}
          title='VENCIMIENTO'
          value={!!expiration ? moment(expiration).format('DD/MM/YYYY') : '0'}
        />
      </div>
      <div className={classes['div-button']}>
        <Button onClick={onClick} custom='quaternary'>
          Ver perfil
        </Button>
      </div>
    </div>
  );
};

export default DetailsClientCard;
